import { addMethod, string, object } from 'yup';
import { validateCardNumber } from '../../services/form-validation-service';
import { CREDIT_CARD_FIELDS } from './constants';
import messages, { validationErrorMessages } from './message';

const { CARD_NAME, CARD_NUMBER, CVV, CARD_EXPIRATION_YEAR, CARD_EXPIRATION_MONTH } = CREDIT_CARD_FIELDS;

const isValidCreditCard = 'isValidCreditCard';
const IS_VALID_CREDIT_CARD = 'is-valid-credit-card';
const isValidCVV = 'isValidCVV';
const IS_VALID_CVV = 'is-valid-cvv';
const isCCUnexpired = 'isCCUnexpired';
const IS_CC_UNEXPIRED = 'is-cc-unexpired';

const buildMetadata = (fieldName) => {
  return { fieldName };
};

const buildErrorMessageCallback = (messageDescriptor) => {
  return () => ({
    messageDescriptor,
  });
};

const buildRequiredMessage = (fieldName) => {
  const messageDescriptor = validationErrorMessages[fieldName] || messages.fieldRequired;
  return buildErrorMessageCallback(messageDescriptor);
};

addMethod(string, isValidCreditCard, function (messageCallback) {
  return this.test(IS_VALID_CREDIT_CARD, messageCallback, (value) => validateCardNumber(value));
});

addMethod(string, isValidCVV, function (messageCallback) {
  return this.test(IS_VALID_CVV, messageCallback, (value) => {
    if (!value) {
      return false;
    }
    const isValidNumber = /^\d+$/.test(value);
    return isValidNumber && value.length >= 3 && value.length <= 4;
  });
});

addMethod(string, isCCUnexpired, function isCreditCardUnexpired(messageCallback) {
  return this.test(IS_CC_UNEXPIRED, messageCallback, (value, { parent }) => {
    const cardExpYear = parent[CARD_EXPIRATION_YEAR];
    const cardExpMonth = parent[CARD_EXPIRATION_MONTH];
    if (!cardExpYear || cardExpYear.length < 4) {
      return true;
    }
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    return (Number(cardExpMonth) >= currentMonth && Number(cardExpYear) >= currentYear) || Number(cardExpYear) > currentYear;
  });
});

const CreditCardSchema = object({
  [CARD_NAME]: string().meta(buildMetadata(CARD_NAME)).required(buildRequiredMessage(CARD_NAME)),
  [CARD_NUMBER]: string()
    .meta(buildMetadata(CARD_NUMBER))
    .isValidCreditCard(buildErrorMessageCallback(messages.invalidCreditCard))
    .required(buildRequiredMessage(CARD_NUMBER)),
  [CVV]: string().isValidCVV(buildErrorMessageCallback(messages.inValidCVV)).meta(buildMetadata(CVV)).required(buildRequiredMessage(CVV)),
  [CARD_EXPIRATION_YEAR]: string()
    .length(4, buildErrorMessageCallback(messages.invalidYearLength))
    .isCCUnexpired(buildErrorMessageCallback(messages.expiredCard))
    .meta(buildMetadata(CARD_EXPIRATION_YEAR))
    .required(buildRequiredMessage(CARD_EXPIRATION_YEAR)),
  [CARD_EXPIRATION_MONTH]: string()
    .isCCUnexpired(buildErrorMessageCallback(messages.expiredCard))
    .meta(buildMetadata(CARD_EXPIRATION_MONTH))
    .required(buildRequiredMessage(CARD_EXPIRATION_MONTH)),
});

export default CreditCardSchema;
